import React from 'react';

import SubFields from '../SubFields';

export default function Section({ field, formik }) {
  return (
    <div>
      <div className="py-3">
        <h3 className="text-sm font-bold mb-2">{field.label}</h3>
        <div>
          {field.fields.map((nestedField) => (
            <SubFields
              row
              key={nestedField.name}
              subFields={[nestedField]}
              formik={formik}
            />
          ))}
        </div>
      </div>
      <hr />
    </div>
  );
}
